import { useState, useEffect } from "react";
import { validateUsersForm } from "../../validations/usersForm";
import { useToastPromise } from "../../components/toastPromise";
import { UsersController } from "../../controllers/usersController";
import { Textbox } from "../../components/textbox";
import { PopupDialog } from "../../components/popupDialog";
import Button from "@mui/material/Button";
import { RoleType } from "../../constants/roleType";

export const Users = ({
  user,
  isOpen = false,
  handleClose,
  getAll,
  selectedData,
}) => {
  const toastPromise = useToastPromise();
  const initialInputs = {
    firstName: "",
    lastName: "",
    email: "",
    contactNum: "",
    password: "",
  };
  const [inputs, setInputs] = useState(initialInputs);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const handleTextChange = (event) => {
    saveInputs(event.target.name, event.target.value);
  };
  const saveInputs = (name, value) => {
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const resetForm = () => {
    setInputs(initialInputs);
    setErrors({});
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateUsersForm(inputs);
    setErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      console.debug("Form submission failed due to validation errors.");
      return;
    }
    console.debug("Form validated successfully.");
    saveUsers();
  };
  const saveUsers = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        selectedData?.id
          ? UsersController.update({
              parameters: {
                ...inputs,
                id: selectedData.id,
                role: RoleType.NORMAL,
                lastModifiedBy: user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              },
              resolve: resolve,
              reject: reject,
            })
          : UsersController.add({
              parameters: {
                ...inputs,
                role: RoleType.NORMAL,
                createdBy: user.uid,
                createdDate: new Date().toLocaleString(),
                lastModifiedBy: user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              },
              resolve: resolve,
              reject: reject,
            });
      }),
      successMessage: (data) => {
        console.debug(data);
        return data;
      },
      errorMessage: (data) => data,
    }).finally(() => {
      setLoading(false);
      handleClose();
      resetForm();
      getAll();
    });
  };
  useEffect(() => {
    if (selectedData) {
      setInputs({
        firstName: selectedData.firstName,
        lastName: selectedData.lastName,
        email: selectedData.email,
        contactNum: selectedData.contactNum,
        password: selectedData.password,
      });
    }
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  return (
    <PopupDialog
      name="users"
      open={isOpen}
      onClose={() => {
        handleClose();
        resetForm();
      }}
      title={selectedData ? "Update Users Detail" : "Add New Users Detail"}
      neutralAction={handleClose}
      positiveAction={
        <Button onClick={handleSubmit} disabled={loading}>
          {loading
            ? selectedData
              ? "Updating"
              : "Adding"
            : selectedData
              ? "Update"
              : "Add"}
        </Button>
      }
      content={
        <form onSubmit={handleSubmit}>
          {selectedData ? (
            <Textbox
              type="text"
              name="id"
              value={selectedData.id}
              placeholder="ID"
              readOnly={true}
            />
          ) : null}
          <Textbox
            type="text"
            name="firstName"
            placeholder="First Name"
            value={inputs.firstName}
            onChange={handleTextChange}
            errorMsg={errors.firstName}
          />
          <Textbox
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={inputs.lastName}
            onChange={handleTextChange}
            errorMsg={errors.lastName}
          />
          {selectedData ? (
            <Textbox
              type="text"
              name="email"
              value={selectedData.email}
              placeholder="Email"
              readOnly={true}
            />
          ) : (
            <Textbox
              type="text"
              name="email"
              placeholder="Email"
              value={inputs.email}
              onChange={handleTextChange}
              errorMsg={errors.email}
            />
          )}
          <Textbox
            type="text"
            name="contactNum"
            placeholder="Contact Number"
            value={inputs.contactNum}
            onChange={handleTextChange}
            errorMsg={errors.contactNum}
          />
          <Textbox
            type="password"
            name="password"
            placeholder="Password"
            value={inputs.password}
            onChange={handleTextChange}
            errorMsg={errors.password}
          />
        </form>
      }
    />
  );
};
